import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fill="#4285F4" d="M22.5 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.19 3.32v2.76h3.54c2.07-1.91 3.23-4.72 3.23-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.54-2.76c-.98.66-2.24 1.05-3.74 1.05-2.87 0-5.3-1.94-6.17-4.55H2.17v2.86A11 11 0 0 0 12 23z"/>
    <path fill="#FBBC05" d="M5.83 14.08a6.6 6.6 0 0 1 0-4.16V7.06H2.17a11 11 0 0 0 0 9.88l3.66-2.86z"/>
    <path fill="#EA4335" d="M12 5.4c1.62 0 3.07.56 4.21 1.65l3.15-3.15A11 11 0 0 0 12 1 11 11 0 0 0 2.17 7.06l3.66 2.86C6.7 7.32 9.13 5.4 12 5.4z"/>
  </svg>
);

const AppleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
  </svg>
);

export const SocialLoginButtons = ({ inline = false }) => {
  const startGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  const startApple = () => {
    toast.info('Sign in with Apple is coming soon', {
      description: 'We\'re working on Apple ID sign-in — use Google or email for now.',
    });
  };

  return (
    <div className={inline ? 'flex gap-2' : 'grid grid-cols-1 gap-2'}>
      <Button type="button" onClick={startGoogle} data-testid="social-google-button" className="jw-btn-gloss-ghost h-11 rounded-[12px] gap-2">
        <GoogleIcon /> Continue with Google
      </Button>
      <Button type="button" onClick={startApple} data-testid="social-apple-button" className="jw-btn-gloss-ghost h-11 rounded-[12px] gap-2">
        <AppleIcon /> Continue with Apple
      </Button>
    </div>
  );
};

export default SocialLoginButtons;
